// @flow

import BrandApi from "../../api/BrandApi/BrandApi";

class BrandService {

    brandApi: BrandApi;

    constructor(brandApi: BrandApi) {
        this.brandApi = brandApi;
    }

    async getBrand() : Promise<Object> {
        return await this.brandApi.getBrand();
    }

    async uploadLogo(logoInformation: ?Object) : Promise<void> {
        if (!logoInformation || !logoInformation.payload) return;

        const uploadUrl = await this.brandApi.requestLogoUploadUrl({
            fileType: logoInformation.fileType,
            contentType: "base64",
        });

        return await this.brandApi.uploadLogoPayload(uploadUrl, logoInformation);
    }

    async createOrUpdateBrand(brand: Object, isUpdateRequest: boolean, logo: ?Object) : Promise<Object> {
        this.uploadLogo(logo);

        if (isUpdateRequest) {
            return await this.brandApi.updateBrand(brand);
        }
        return await this.brandApi.createBrand(brand);
    }
}

export default BrandService;
